const _ = require("lodash");
const colors = require("../../util/ColorUtil").getDiagramColors();

const {findOptionalArgument, findArguments} = require("../util/ParserHelpers");

const minishapeParser = function(ps) {
	// required args: shape
	// optional args: whether to fill, which color to use, scale
	// should this be written as JSON? no

	const args = findArguments(ps, 1);
	if (!args) {
		ps.pushError("minishape requires specifying a shape to draw");
		return false;
	}
	// const points = [];
	let error = false;
	const points = args[0].text.split(";").map(coords =>
		coords.split(",").map(xOrY => {
			if (isNaN(xOrY)) {
				ps.pushError(`minishape coordinate ${xOrY} is not a number`);
				error = true;
			}
			return Number(xOrY);
		})
	);

	if (error) {
		return false;
	}

	if (points.length !== 0 && !points.every(coords => coords.length === 2)) {
		ps.pushError(
			`at least one minishape coordinate is not in (x, y) format: ${points}`
		);
		return false;
	}

	/* Optional arguments: write through */
	const options = {
		maxXY: 5,
		fill: false,
		color: "blue",
		scale: 1,
		showPts: false,
		lineWidth: 1,
	};

	let optArg;
	let optCount = 0;

	// eslint-disable-next-line no-cond-assign
	while ((optArg = findOptionalArgument(ps).text)) {
		switch (optCount) {
			case 0:
				options.showPts = optArg === "true";
				break;
			case 1:
				if (isNaN(optArg)) {
					ps.pushError(`maxXY optional arg ${optArg} is not a Number`);
					return false;
				}
				options.maxXY = Number(optArg);
				break;
			case 2:
				options.fill = optArg === "true";
				break;
			case 3:
				options.color = optArg;
				break;
			case 4:
				if (isNaN(optArg)) {
					ps.pushError(`scale optional arg ${optArg} is not a Number`);
					return false;
				}
				options.scale = Number(optArg);
				break;
			case 5:
				if (isNaN(optArg)) {
					ps.pushError(`lineWidth optional arg ${optArg} is not a Number`);
					return false;
				}
				options.lineWidth = Number(optArg);
				break;
		}
		optCount++;
	}

	options.color = colors[options.color] || colors.blue;

	for (const xOrY of _.flatten(points)) {
		if (xOrY > options.maxXY) {
			ps.pushError(`coordinate with value ${xOrY} out of bounds`);
			return false;
		}
	}

	return [
		{
			type: "minishape",
			points,
			options,
		},
	];
};

const minishapeNode = {
	// add children
	draw(rc, x, y, node, measure) {
		const {context} = rc;
		const {points, options} = node;
		const {
			maxXY,
			fill,
			color,
			scale,
			showPts,
			lineWidth,
			fontSize = 20,
		} = options;
		let {width} = measure;
		let height = width;

		// switch width, height, x, y to width, height, x and y of the grid part
		width -= 20 * scale;
		height -= 20 * scale;
		x += 10 * scale;
		y += 10 * scale;
		y -= fontSize - 2;

		// show dots option

		const mapCoords = ([cartX, cartY]) => {
			return [
				x + ((cartX * width) / maxXY) * scale,
				y + height / 2 - (cartY / maxXY) * height * scale,
			];
		};

		context.save();

		context.strokeStyle = color;
		context.fillStyle = color;
		context.lineWidth *= lineWidth;

		if (showPts) {
			for (let cartX = 0; cartX <= maxXY; cartX++) {
				for (let cartY = 0; cartY <= maxXY; cartY++) {
					const [canvasX, canvasY] = mapCoords([cartX, cartY]);
					context.beginPath();
					context.arc(canvasX, canvasY, context.lineWidth * 2, 0, 360);
					context.fill();
				}
			}
		}
		const canvasPts = points.map(mapCoords);
		if (canvasPts.length) {
			context.beginPath();
			context.moveTo(...canvasPts[0]);

			for (let i = 1; i < canvasPts.length; i++) {
				context.lineTo(canvasPts[i]);
			}
			context.lineTo(canvasPts[0]);

			if (fill) {
				context.fill();
			} else {
				context.stroke();
			}
			context.restore();
		}
	},

	measure(rc, fontInfo, props, node) {
		const fontSize = fontInfo.size;
		const scale = node.options.scale;
		const top = 60 * scale;
		const bottom = 60 * scale;
		const width = 120 * scale;

		return {
			top,
			bottom,
			width,
			fontSize,
		};
	},
	readAloud: "",
};

module.exports = {
	parsers: {
		mathCommands: {
			minishape: minishapeParser,
		},
	},
	nodes: {
		minishape: minishapeNode,
	},
};
